export enum LeadTypeEnum {
  CheckAvailability = 1,
  PriceInquiry = 2,
  TestDrive = 3,
  FinancingInquiry = 4,
  AskQuestion = 5,
  RequestHistoryReport = 6,
}

export type Lead = {
  id: LeadTypeEnum
  name: string
  message?: string
}

const leadList: Lead[] = [
  {
    id: LeadTypeEnum.CheckAvailability,
    name: 'Check Availability',
  },
  {
    id: LeadTypeEnum.PriceInquiry,
    name: 'Best Price Inquiry',
  },
  {
    id: LeadTypeEnum.RequestHistoryReport,
    name: 'Request History Report',
  },
  {
    id: LeadTypeEnum.FinancingInquiry,
    name: 'Financing Inquiry',
  },
  {
    id: LeadTypeEnum.TestDrive,
    name: 'Schedule a Test Drive',
  },
  {
    id: LeadTypeEnum.AskQuestion,
    name: 'Ask a Question',
  },
]

function getLead(id: number, title: string): string {
  switch (id) {
    case LeadTypeEnum.CheckAvailability:
      return `I am interested in the ${title} you have listed on Cruz.com. Is it still available?`
    case LeadTypeEnum.PriceInquiry:
      return `I would like to know your best price for the ${title} you have listed on Cruz.com.`
    case LeadTypeEnum.TestDrive:
      return `I would like to schedule a test drive for the ${title} you have listed on Cruz.com.`
    case LeadTypeEnum.FinancingInquiry:
      return `I am interested in financing options for the ${title} you have listed on Cruz.com.`
    case LeadTypeEnum.RequestHistoryReport:
      return `I would like to request a history report for the ${title} you have listed on Cruz.com.`
    case LeadTypeEnum.AskQuestion:
      return `I have a question about the ${title} you have listed on Cruz.com.`
    default:
      return ''
  }
}

export const lead = {
  leadList, getLead, LeadTypeEnum
}